// src/components/site/SiteLayout.tsx — Site officiel Vanessa
// Cadre commun à toutes les pages : lien d'évitement, en-tête, contenu, pied de page.
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

const BASE_TITLE = 'Vanessa';
const TITLES: Record<string, string> = {
    '/vanessa': 'Qui est Vanessa', '/produits': 'Produits', '/confiance': 'Confiance et sécurité',
    '/developpeurs': 'Développeurs', '/developpeurs/demarrage': 'Démarrage rapide', '/documentation': 'Documentation de l’API',
    '/tarifs': 'Tarifs', '/statut': 'Statut de l’API', '/entreprises': 'Entreprises et partenaires', '/guide': 'Guide d’utilisation',
    '/faq': 'Questions fréquentes', '/contact': 'Contact', '/confidentialite': 'Politique de confidentialité',
    '/conditions': 'Conditions d’utilisation', '/connexion': 'Connexion', '/inscription': 'Inscription', '/console': 'Console développeur',
    '/admin': 'Administration',
};

export const SiteLayout = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const page = TITLES[pathname] || (pathname.startsWith('/produits/') ? 'Produits' : '');
        document.title = pathname === '/' || !page ? `${BASE_TITLE} — celle qui vous ressemble et vous rassemble` : `${page} — ${BASE_TITLE}`;
    }, [pathname]);

    // Nouvelle page : retour en haut (sauf si le lien vise une ancre).
    useEffect(() => {
        if (hash) {
            document.getElementById(hash.slice(1))?.scrollIntoView();
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return (
        <div className="flex min-h-screen flex-col bg-cream">
            <a
                href="#contenu"
                className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-full focus:bg-brand focus:px-4 focus:py-2 focus:font-semibold focus:text-ink"
            >
                Aller au contenu
            </a>
            <SiteHeader />
            <main id="contenu" className="flex-1">
                <Outlet />
            </main>
            <SiteFooter />
        </div>
    );
};
